module.exports = __webpack_public_path__ + "static/img/policyType5-process.e9a69988.png";